module.exports = __webpack_public_path__ + "img/upload-new-document.f69308ac.svg";